import { render, staticRenderFns } from "./AdminEvents.vue?vue&type=template&id=6e8a2d57"
import script from "./AdminEvents.vue?vue&type=script&lang=ts"
export * from "./AdminEvents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports